var render, staticRenderFns
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"
import style0 from "./Collapsible.vue?vue&type=style&index=0&id=76024eef&prod&scoped=true&lang=css"
import style1 from "./Collapsible.vue?vue&type=style&index=1&id=76024eef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76024eef",
  null
  
)

export default component.exports